<template>
  <v-container grid-list-md>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="400px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{}">
        <v-btn
          fab
          :loading="loading"
          color="success"
          dark
          @click="onOpenExpense"
        >
          <v-icon>fas fa-hands-helping</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          New Fixed Expense
          <v-spacer></v-spacer>
          <v-btn text icon @click.stop="close">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" v-model="valid" class="mx-5">
          <v-text-field
            outlined
            v-model.trim="expense.expensName"
            :rules="[v => !!v || 'Expense Name is required']"
            label="Expense Name"
            color="success"
            prepend-inner-icon="fas fa-user-tie"
            required
          >
          </v-text-field>
          <v-text-field
            outlined
            v-model="expense.contact"
            :rules="[v => !!v || 'Contact is required']"
            label="Contact"
            color="success"
            prepend-inner-icon="fas fa-mobile-alt"
            required
          >
          </v-text-field>

          <v-text-field
            outlined
            v-model.trim="expense.IDNomber"
            validate-on-blur
            :rules="[v => !!v || 'Passport or other ID is required']"
            label="ID Number"
            color="success"
            prepend-inner-icon="fas fa-address-card"
            required
          >
          </v-text-field>

          <v-select
            outlined
            :loading="loading"
            v-model.trim="expense.expenseType"
            :rules="[v => !!v || 'Expense Type is required']"
            :items="expenseTypes"
            item-text="AccountName"
            item-value="_id"
            label="Expense Type"
            prepend-inner-icon="fas fa-search-dollar"
            @click:prepend-inner="OnNewExpense"
            required
            no-data-text="Refresh the page"
          ></v-select>

          <BaseNumInput
            outlined
            label="Monthly Amount"
            v-model.number="expense.Amount"
          ></BaseNumInput>
          <small class="text-center warning white--text d-block"
            >Note the expense amount is based on
            <strong class="black--text">{{ UsersToken.CashBase }}</strong>
          </small>
        </v-form>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            :color="isEditing ? 'error' : 'teal'"
            class="white--text"
            width="200px"
            :loading="clicked"
            @click="UpdateOrSave"
          >
            {{ isEditing ? "Update" : "Register" }}
            <!-- <v-icon right>fas fa-plus</v-icon> -->
          </v-btn>
        </v-card-actions>
        <NewExpense
          :loadFunction="onOpenExpense"
          :AccountType="8"
          title="New Fixed Expense"
          @OnClosed="OpenExpense = false"
          :OpenNewExpense="OpenExpense"
        >
        </NewExpense>
        <p v-if="ErrorMsg" class="red--text d-flex mt-2 justify-center">
          {{ ErrorMsg }}
        </p>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    loadFunction: { type: Function, required: true },
    isEditing: { type: Boolean, required: true, default: false },
    OnEdite: { type: Object, required: true },
  },
  components: {
    NewExpense: () => import("@/components/util/NewAccount.vue"),
  },
  data() {
    return {
      ID: "",
      dialog: false,
      loading: false,
      clicked: false,
      OpenExpense: false,
      valid: true,
      date: null,
      expenseTypes: [],
      ErrorMsg: "",
      expense: {
        expensName: null,
        contact: null,
        IDNomber: null,
        expenseType: null,
        Amount: 0,
      },
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
  },
  watch: {
    isEditing(val) {
      // console.log(val);
      if (val) {
        // this.dialog = true;
        this.onOpenExpense();
        this.ExpenEdite(this.OnEdite);
      }
    },
  },

  methods: {
    ExpenEdite(E_exp) {
      // console.log(E_exp);
      this.ID = E_exp._id;
      this.ErrorMsg = "";
      // this.isEditing = true;
      this.expense.expensName = E_exp.expensName;
      this.expense.contact = E_exp.contact;
      this.expense.IDNomber = E_exp.IDNomber;
      this.expense.expenseType = E_exp.expenseType;
      this.expense.Amount = E_exp.Amount;
    },
    close() {
      // console.log("colosed");
      this.dialog = false;
      this.ID = null;
      this.expense.expensName = null;
      this.expense.contact = null;
      this.expense.IDNomber = null;
      this.expense.expenseType = null;
      this.expense.Amount = 0;

      this.$emit("input", false);

      this.$refs.form.resetValidation();
      // this.loadFunction();
    },
    UpdateOrSave() {
      if (this.isEditing) this.OnUpdateExpense();
      else this.OnSaveExpense();
    },
    GetReq(url = "/expense", query = { fixed: true }) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OnNewExpense() {
      this.OpenExpense = true;
    },
    onOpenExpense() {
      this.loading = true;
      this.GetReq()
        .then(exp => {
          this.loading = false;
          // console.log(exp);
          this.expenseTypes = exp.data;
          this.dialog = true;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
      // console.log(this.UsersToken);
    },
    isGreaterthanZero(v) {
      return v.toString().replace(/,/g, "") > 0 || "Monthly Amount is required";
    },
    OnUpdateExpense() {
      // console.log("Updating");
      this.ErrorMsg = "";
      if (this.$refs.form.validate() && this.ID) {
        this.clicked = true;
        delete this.expense.date;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: "/expense/fixed",
            data: { ...this.expense, ID: this.ID },
          })
          .then(() => {
            this.clicked = false;
            // this.$refs.SupplierForm.reset();
            // console.log(result);
            this.ID = "";
            this.loadFunction();
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            if (err.response && err.response.data)
              this.ErrorMsg = err.response.data;
            // console.log(err);
          });
      }
    },
    OnSaveExpense() {
      try {
        if (this.$refs.form.validate()) {
          this.clicked = true;
          // console.log(this.expense);
          this.expense.date = this.Current().date;
          this.$store
            .dispatch("INSERT_ONLY", {
              url: "/expense/fixed",
              data: this.expense,
            })
            .then(() => {
              this.loadFunction();
              this.close();
              // this.$refs.form.reset();
              this.clicked = false;
              // console.log(result);
            })
            .catch(err => {
              this.clicked = false;
              // console.log(err.response);
              if (err.response.status === 400)
                this.ErrorMsg = err.response.data;
              if (err.response.status === 409)
                this.ErrorMsg = this.expense.contact + " is registred";
              else this.ErrorMsg = err.response.data;
            });
        }
      } catch (error) {
        console.log(error);
      }
      this.ErrorMsg = "";
    },
  },
  // created() {
  //   console.log(this.Current());
  //   console.log("Date");
  // }
};
</script>
